export function magnify(imgID: string, zoom: number, elementId: string) {
  let w, h, bw;
  const subtarget = document.querySelector(elementId);
  const img =
    subtarget && subtarget.shadowRoot
      ? (subtarget.shadowRoot.getElementById(imgID) as HTMLImageElement)
      : (document.getElementById(imgID) as HTMLImageElement);
  /*create magnifier glass:*/
  const glass = document.createElement('DIV');
  glass.setAttribute('class', 'img-magnifier-glass');
  glass.setAttribute('id', 'magnifier-glass');

  /*insert magnifier glass:*/
  if (img.parentElement) {
    img.parentElement.insertBefore(glass, img);
  }

  /*execute a function when someone moves the magnifier glass over the image:*/
  glass.addEventListener('mousemove', moveMagnifier);
  img.addEventListener('mousemove', moveMagnifier);

  function moveMagnifier(e: MouseEvent) {
    let x, y;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*set background properties for the magnifier glass:*/
    glass.style.backgroundImage = "url('" + img.src + "')";
    glass.style.backgroundRepeat = 'no-repeat';
    glass.style.backgroundSize =
      img.width * zoom + 'px ' + img.height * zoom + 'px';
    bw = 3;
    w = glass.offsetWidth / 2;
    h = glass.offsetHeight / 2;

    /*get the cursor's x and y positions:*/
    const pos = getCursorPos(e);
    x = pos.x;
    y = pos.y;
    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x > img.width - w / zoom) {
      x = img.width - w / zoom;
    }
    if (x < w / zoom) {
      x = w / zoom;
    }
    if (y > img.height - h / zoom) {
      y = img.height - h / zoom;
    }
    if (y < h / zoom) {
      y = h / zoom;
    }
    /*set the position of the magnifier glass:*/
    glass.style.left = x - w + 10 + 'px';
    glass.style.top = y - h + 10 + 'px';
    /*display what the magnifier glass "sees":*/
    glass.style.backgroundPosition =
      '-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
  }
  function getCursorPos(e: MouseEvent) {
    let x = 0,
      y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/
    const a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/

    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }
}

export function removeMagnify(elementId: string): void {
  const subtarget = document.querySelector(elementId);
  const element =
    subtarget && subtarget.shadowRoot
      ? (subtarget.shadowRoot.getElementById(
          'magnifier-glass'
        ) as HTMLDivElement)
      : (document.getElementById('magnifier-glass') as HTMLDivElement);

  if (element.parentNode) {
    element.parentNode.removeChild(element);
  }
}
